import { ColDef, ColGroupDef, ValueFormatterParams } from '@ag-grid-community/core';
import { COLUMN_TYPES_DEFAULT } from '@alk/grid-utils';
import { compareDesc, parseISO } from 'date-fns';
import { IGridDataRow } from '../../interfaces';
import { ISO8601 } from '@alk/dates';

export function filterComparatorForDate(filterDate: Date, cellValue: ISO8601): number {
    const [ dayOnlyIso ] = Boolean(cellValue) ? cellValue.split('T') : undefined;
    const cellValueAsDate = parseISO(dayOnlyIso);

    return compareDesc(filterDate, cellValueAsDate);
}

export function isColumnDateType(columnDef: ColDef | ColGroupDef): boolean {
    // Type guard to exclude ColGroupDef
    if ('type' in columnDef) {
        if (Array.isArray(columnDef.type)) {
            return columnDef.type.includes('date');
        } else {
            return columnDef.type === 'date';
        }
    }

    return false;
}

export function setFloatingFilterOnDateTypeColumn(
    columnDefs: Array<ColDef | ColGroupDef>,
    floatingFilter: boolean,
): Array<ColDef | ColGroupDef> {
    return columnDefs
        .map(def => {
            if (isColumnDateType(def)) {
                return {
                    ...def,
                    floatingFilter,
                };
            }

            return def;
        });
}

export const isNumber = (value: unknown): value is number => Number.isFinite(value);

export const formatRowData = (columnDefs: Array<ColDef>) => (rowData: IGridDataRow): Record<string, string> => {
    const formattedData = {};

    columnDefs.forEach(columnDef => {
        const rawValue = rowData[ columnDef.field ];
        const formatterParams = { value: rawValue };

        let formattedValue: string;

        if (columnDef.valueFormatter instanceof Function) {
            const currencyKey = columnDef.cellRendererParams?.currencyKey;

            if (Boolean(currencyKey) && !isNumber(rawValue)) {
                formattedValue = '-';
            } else if (Boolean(currencyKey) && isNumber(rawValue)) {
                formattedValue = columnDef.valueFormatter({
                    value: formatterParams,
                } as ValueFormatterParams);
                formattedValue += ` ${ rowData[ currencyKey ] }`;
            } else {
                formattedValue = columnDef.valueFormatter({
                    ...formatterParams,
                    data: rowData,
                } as ValueFormatterParams);
            }

        } else if (columnDef.cellRendererParams?.getSleeveValue instanceof Function) {
            formattedValue = columnDef.cellRendererParams.getSleeveValue(rawValue);
        } else {
            formattedValue = rawValue as string;
        }

        formattedData[ columnDef.field ] = formattedValue || '-';
    });

    return formattedData;
};

export const mergeTypeColDef = (columnDefs: Array<ColDef>) : Array<ColDef> => (
    columnDefs.map((colDef: ColDef) => {
        if (colDef.type instanceof Array) {
            let mergedColDef = {};
            colDef.type.forEach(type => {
                const typeColDef = COLUMN_TYPES_DEFAULT[ type ];
                mergedColDef = { ...mergedColDef, ...typeColDef };
            });
            return { ...mergedColDef, ...colDef };
        }
        return colDef;
    })
);
